<template lang="pug">
	.div.mt-3
		table.table.table-striped(v-if="resultados && resultados.length > 0")
			thead.bg-dark.text-white
				tr
					th Fecha generada
					th Cliente
					th Contrato
					th ID Factura
					th Importe neto factura
					th Agente
					th % Comisión
					th Importe comisión
					th Estado
			tbody
				tr(
					v-for="linea in resultados"
					:key="linea.ComisionID"
				)
					td {{linea.FechaGenerada | moment('DD-MM-YYYY')}}
					td {{linea.ClienteNombre}}
					td {{linea.ContratoTitulo}}
					td {{linea.FacturacionID}}
					td {{linea.ImporteNeto | currency('')}} €
					td {{linea.AgenteNombre}}
					td {{linea.Comision}} %
					td {{linea.ImporteComision | currency('')}} €
					td
						span(v-if="linea.FechaPagada") Pagada
						span(v-else) Pendiente

			tbody
				tr.bg-dark.text-white
					td.text-center(colspan="3", style="font-size:1.5em;")
						b Comisiones generadas
						br
						| {{importeComisiones | currency('')}} €
					td.text-center(colspan="3", style="font-size:1.5em;")
						b Comisiones pagadas
						br
						| {{importePagado | currency('')}} €
					td.text-center(colspan="4", style="font-size:1.5em;")
						b Comisiones pendientes
						br
						| {{importePendiente | currency('')}} €
		.div.text-dark.text-center.mt-3.p-5(v-else)
			h2
				span.fa.fa-ban
				br
				| No hay resultados
</template>

<script>
export default {
	props: ['resultados'],
	computed: {
		importeComisiones () {
			if (!this.resultados) {
				return 0
			}

			return this.resultados.reduce((ant, actual) => {
				if (actual.ImporteComision) {
					ant = ant + actual.ImporteComision
				}
				return ant
			}, 0)
		},
		importePagado () {
			if (!this.resultados || this.resultados.length === 0) {
				return 0
			}

			return this.resultados.reduce((ant, actual) => {
				if (actual.FechaPagada) {
					ant = ant + actual.ImporteComision
				}
				return ant
			}, 0)
		},
		importePendiente () {
			return this.importeComisiones - this.importePagado
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/comisiones/resultados.vue